// extracted by mini-css-extract-plugin
export var hasPaddingStyle = "sr_image_wrapper_inner-module--hasPaddingStyle--YnYAW";
export var headingWrapperStyle = "sr_image_wrapper_inner-module--headingWrapperStyle--JMc0a";
export var imageInnerStyle = "sr_image_wrapper_inner-module--imageInnerStyle--kCecU";